export var SocketEvent;
(function (SocketEvent) {
    SocketEvent["SUBSCRIBE_NOTIFICATIONS"] = "subscribeNotifications";
    SocketEvent["Error"] = "error";
    SocketEvent["SUBSCRIBE_CAMPAIGN_UPDATES"] = "subscribeCampaignUpdates";
    SocketEvent["JOIN_ROOM"] = "joinRoom";
    SocketEvent["LEAVE_ROOM"] = "leaveRoom";
    SocketEvent["ROOM_EVENT"] = "roomEvent";
})(SocketEvent || (SocketEvent = {}));
export var SocketErrorReason;
(function (SocketErrorReason) {
    SocketErrorReason["UNAUTHORIZED"] = "401Unauthorized";
    SocketErrorReason["INCORRECT_EVENT_BODY"] = "400IncorrectEventBody";
    SocketErrorReason["UNKNOWN_ERROR"] = "500UnknownError";
})(SocketErrorReason || (SocketErrorReason = {}));
export var SubscriberAction;
(function (SubscriberAction) {
    SubscriberAction["Subscribe"] = "subscribe";
    SubscriberAction["Unsubscribe"] = "unsubscribe";
})(SubscriberAction || (SubscriberAction = {}));
export var SocketRoom;
(function (SocketRoom) {
    SocketRoom["MY_INTENT_MODELS"] = "myIntentModels";
    SocketRoom["EDIT_CAMPAIGN"] = "editCampaign";
    SocketRoom["USER_NOTIFICATIONS"] = "userNotifications";
    SocketRoom["TAL_TOOLS"] = "talTools";
})(SocketRoom || (SocketRoom = {}));
export var RoomEventType;
(function (RoomEventType) {
    RoomEventType["LIST_CAMPAIGNS_STATE_UPDATE"] = "listCampaignsStateUpdate";
    RoomEventType["ACCOUNTS_SUMMARY_UPDATE"] = "accountsSummaryUpdate";
    RoomEventType["NOTIFICATION"] = "notification";
    RoomEventType["TAL_TOOLS_PROCESSING_UPDATE"] = "talToolsProcessingUpdate";
})(RoomEventType || (RoomEventType = {}));
//# sourceMappingURL=SocketGateway.js.map